<template>
  <QTabs
    shrink
    indicator-color="transparent"
  >
    <QRouteTab
      v-for="nav in navs"
      :to="nav.route"
      content-class="font-bold"
      :class="$route.name.includes(nav.route.name) ? 'text-secondary': ''"
    >
      <div class="flex flex-nowrap items-center justify-center gap-2 text-base px-5">
        {{ nav.label }}
        <ImgIcon
          :src="MenuIcon"
        />
      </div>
    </QRouteTab>
  </QTabs>
</template>
<script setup>
import MenuIcon from '@/icons/menu-icon.svg'
import ImgIcon from "@/components/Icons/ImgIcon.vue";

const navs = [
  {
    label: '국내형스포츠',
    route: { name: 'prematches' },
  },
  {
    label: '유럽형스포츠',
    route: { name: 'pregames' },
  },
  {
    label: '라이브스포츠',
    route: { name: 'lives' },
  },
  {
    label: '카지노',
    route: { name: 'casinos' },
  },
  {
    label: '슬롯',
    route: { name: 'slots' },
  },
  // {
  //   label: '그래프게임',
  //   route: { name: 'pragmatic', params: { id: 33, code: 1302 } },
  // },
  {
    label: '미니게임',
    route: { name: 'mini-games' },
  },
  {
    label: '가상스포츠',
    route: { name: 'virtual-games' },
  },
  // {
  //   label: '로또6/45',
  //   route: { name: 'duotone-balls' },
  // },
]

</script>
<style>
.q-tab__label {
  @apply text-base font-black;
}
</style>
